module.exports = __webpack_public_path__ + "static/media/pokeball_screen.be724d2a.png";